/**
 * Union vector `1:4550` asset (Figma MCP export):
 * `http://localhost:3845/assets/28aa4dcee2e4c6ad003c15a219be8e4edfaeb7bf.svg`
 */
/** RGB stops from MCP rating pills `1:4609`, `1:4618`, `1:4615` (horizontal hue across the bar set). */
export const HOME_INDEX_CHART_RGB_STOPS = [
    [198, 33, 24],
    [254, 155, 9],
    [51, 129, 1],
];
/** ~ midpoint between MCP overlay stops `1.53%` … `50.171%` … `113.36%` for hue break red → amber → green. */
const HUE_BREAK = 0.52;
const N = 64;
function clamp255(n) {
    return Math.max(0, Math.min(255, Math.round(n)));
}
function lerp3(a, b, t) {
    return [
        clamp255(a[0] + (b[0] - a[0]) * t),
        clamp255(a[1] + (b[1] - a[1]) * t),
        clamp255(a[2] + (b[2] - a[2]) * t),
    ];
}
/** Main bar color at horizontal index (left = red family, right = green). */
export function homeIndexBarMainRgb(index, total) {
    const u = total <= 1 ? 0 : index / (total - 1);
    const [c0, c1, c2] = HOME_INDEX_CHART_RGB_STOPS;
    if (u <= HUE_BREAK) {
        const t = HUE_BREAK <= 0 ? 0 : u / HUE_BREAK;
        return lerp3(c0, c1, t);
    }
    const t = u >= 1 ? 1 : (u - HUE_BREAK) / (1 - HUE_BREAK);
    return lerp3(c1, c2, t);
}
/**
 * Bar top color from `compositeValue` (0–100): &lt;50, 50–60, … 90–100 (Figma risk bands).
 * First gradient stops from Figma MCP `get_design_context`: `76:870`, `76:872`, `76:874`, `76:876`, `76:878`, `76:880`.
 */
export function homeIndexBarMainRgbForCompositeValue(raw) {
    const v = Math.max(0, Math.min(100, raw));
    if (v < 50) {
        return [198, 33, 24];
    }
    if (v < 60) {
        return [228, 39, 26];
    }
    if (v < 70) {
        return [254, 155, 9];
    }
    if (v < 80) {
        return [253, 190, 1];
    }
    if (v < 90) {
        return [166, 239, 48];
    }
    return [51, 129, 1];
}
/**
 * Bar bottom (gradient base) for the same bands — second stops from the same Figma nodes as
 * `homeIndexBarMainRgbForCompositeValue`.
 */
export function homeIndexBarBaseRgbForCompositeValue(raw) {
    const v = Math.max(0, Math.min(100, raw));
    if (v < 50) {
        return [83, 11, 22];
    }
    if (v < 60) {
        return [101, 13, 18];
    }
    if (v < 70) {
        return [112, 37, 8];
    }
    if (v < 80) {
        return [162, 109, 5];
    }
    if (v < 90) {
        return [26, 144, 19];
    }
    return [3, 57, 5];
}
/** Vertical gradient base: darker variant of `top` (Figma: brighter at bar tip). */
export function homeIndexBarBaseRgb(top) {
    const k = 0.38;
    return [clamp255(top[0] * k), clamp255(top[1] * k), clamp255(top[2] * k)];
}
export function homeIndexBarRgbCss(rgb) {
    return `rgb(${rgb[0]}, ${rgb[1]}, ${rgb[2]})`;
}
/**
 * Bar heights 20 → 84 with accelerating curve (exponent > 1) to match MCP screenshot bar envelope.
 */
export const HOME_INDEX_CHART_DATA = Array.from({ length: N }, (_, idx) => {
    const t = N <= 1 ? 0 : idx / (N - 1);
    const curve = Math.pow(t, 1.35);
    const v = 20 + (84 - 20) * curve;
    return {
        i: idx,
        v,
        dateOfData: "",
        compositeValue: v,
    };
});
